import axios from 'axios';
import apiConfig from '../api.config';

export default function deleteHotelRequest({ hotelId }) {
  const {
    host,
    URIs: { hotels },
  } = apiConfig;

  const uri = `${host}${hotels}/${hotelId}`;

  return axios
    .delete(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
